<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
                  <c-form-item type="input" label="任务名称:" name="task_name"></c-form-item>
                  <c-form-item type="checkbox" label="任务类型:" name="task_type" :options="taskType"></c-form-item>
                  <c-form-item type="checkbox" label="审核状态:" name="state" :options="state"></c-form-item>
                  <c-form-item type="checkbox" label="发放状态:" name="send_state" :options="sendState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" @click="navigateTo('/coupon_task_add')">新建发放任务</c-button>
			</m-operate>
			
			<c-table ref="table">
                <c-table-column
                    label="审核状态"
                    name="state"
                    width="80"
                >
					<template v-slot="{data}">
                        <span v-if="data.state == 0" style="color:#999">草稿</span>
                        <span v-if="data.state == 1" style="color:dodgerblue">待审核</span>
                        <span v-if="data.state == 2" style="color:green">审核通过</span>
                        <span v-if="data.state == -1" style="color:red">审核驳回</span>
					</template>
				</c-table-column>

                <c-table-column
                    label="任务类型"
                    name="task_type"
                    width="80"
                >
                  <template v-slot="{data}">
                    <span v-if="data.task_type == 0" style="color:darkcyan">自动发放</span>
                    <span v-if="data.task_type == 1" style="color:darkgoldenrod">自行领券</span>
                  </template>
                </c-table-column>

				<c-table-column
					label="发放状态"
					name="send_state"
                  width="80"
                >
					<template v-slot="{data}">
            <!--发放状态：0：待发放，1：已发放，2：终止发放，3：发放异常-->
            <span v-if="data.state == 2 && data.task_type == 0 && data.send_state == 0" style="color:#999">待发放</span>
            <span v-else-if="data.state == 2 && data.task_type == 1 &&data.send_state == 0" style="color:dodgerblue">领取中</span>
            <span v-else-if="data.state == 2 && data.send_state == 1" style="color:dodgerblue">已发放</span>
            <span v-else-if="data.state == 2 && data.send_state == 2" style="color:red">终止发放</span>
            <span v-else-if="data.task_type == 0 &&data.send_state == 3" style="color:red">发放异常</span>
            <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="任务名称"
					name="task_name"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="优惠券"
					name="detail"
					width="300"
				></c-table-column>
				
				<c-table-column
					label="发放会员"
					name="user_count"
				>
                  <template v-slot="{data}">
                    <span v-if="data.task_user_type == 0" style="color:#999">全部会员</span>
                    <span v-if="data.task_user_type == 1" style="color:dodgerblue">指定会员组</span>
                    <span v-if="data.task_user_type == 2" style="color:green">指定会员({{data.user_count}})</span>
                  </template>
                </c-table-column>

				<c-table-column
					label="备注"
					name="remark"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="创建人"
					name="create_user_realname"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="审核时间"
					name="approval_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
                    fixed="right"
					label="操作"
					width="150"
				>
					<template v-slot="row">
						<c-table-button v-if="row.data.state != 0" @click="navigateTo(`/coupon_task_detail/${row.data.id}`)">查看</c-table-button>
						<c-table-button v-if="row.data.state <= 0" @click="navigateTo(`/coupon_task_edit/${row.data.id}`)">编辑</c-table-button>
						<c-table-button v-if="row.data.state <= 0" @click="deleteTask(row)">删除</c-table-button>
						<c-table-button v-if="row.data.state == 1" @click="navigateTo(`/coupon_task_verify/${row.data.id}`)">审核</c-table-button>
						<c-table-button v-if="row.data.task_type == 1 && row.data.state == 2 && row.data.send_state == 0" @click="stopTask(row)">终止发放</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_coupon_task',
        props: {
            apply_state: String
        },

		data() {
			return {
        taskType:[
          {name:'自动发放',value:0},
          {name:'自行领取',value:1}
        ],
				state: [{
					name: '草稿',
					value: 0
				}, {
					name: '待审核',
					value: 1
				}, {
					name: '审核通过',
					value: 2
				}, {
					name: '驳回',
					value: -1
				}],
				
				sendState: [{
					name: '待发放',
					value: 0
				}, {
					name: '已发放',
					value: 1
				}, {
					name: '终止发放',
					value: 2
				}, {
					name: '发放异常',
					value: 3
				}]
			}
		},

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

		computed: {
			stateText() {
				var state = {};
				this.state.forEach(item => {
					state[item.value] = item.name;
				});
				
				return state;
			},
			
			sendStateText() {
				var state = {};
				this.sendState.forEach(item => {
					state[item.value] = item.name;
				});
				
				return state;
			},

            defaultSearch() {
                let param = {
                    state: this.apply_state ? this.apply_state.split(',') : [],
                }

                return param;
            }
		},
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('couponTaskList.update', () => {
				this.$refs.search.search();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/couponInfo/task/list',
					data
				});
			},
			deleteTask(item) {
				this.$confirm({
					text: '确定要删除发放任务【'+item.data.task_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/couponInfo/task/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
      stopTask(item) {
				this.$confirm({
					text: '确定要终止发放任务【'+item.data.task_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/couponInfo/task/stop',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '终止成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>